export type LicenseExpiryAlert = 'expired' | 'soon' | null;

const SOON_DAYS = 30;

export function licenseExpiryAlert(expiryIso: string | null | undefined): LicenseExpiryAlert {
  if (!expiryIso) return null;
  const expiry = new Date(expiryIso);
  if (Number.isNaN(expiry.getTime())) return null;
  const now = new Date();
  const msPerDay = 24 * 60 * 60 * 1000;
  const daysLeft = Math.ceil((expiry.getTime() - now.getTime()) / msPerDay);
  if (daysLeft < 0) return 'expired';
  if (daysLeft <= SOON_DAYS) return 'soon';
  return null;
}

export function formatLicenseDate(expiryIso: string | null | undefined): string {
  if (!expiryIso) return '—';
  try {
    return new Date(expiryIso).toLocaleDateString();
  } catch {
    return expiryIso;
  }
}
